import {
  Button,
  Card,
  Grid,
  Icon,
  List,
  Modal,
  NavBar,
  SearchBar,
  Tabs,
  Toast,
  WhiteSpace,
  WingBlank,
} from "antd-mobile";

//   import { ProductionTaskRejectStatItemDTO } from "../../schema";
import React, { useCallback, useEffect, useState } from "react";
import { useHistory } from "react-router";
import styled from "styled-components";
import instance from "../../../util/axios";
const HomePage = styled.div`
  .body {
    // width:100%;
    padding: 0;
    margin: 0;
    background-color: #ffffff;
  }
  .title {
    background: url("/images/bg_mine.png");
    height: 164px;
    width: 100%;
    position: relative;
  }
  .titleimg {
    width: 100%;
    height: 100%;
  }
  .titlediv {
    position: absolute;
    top: 30%;
    left: 10%;
    width: 50%;
    height: 50%;
    // border: 1px solid gray;
    display: flex;
    justify-content: space-around;
    align-items: center;
  }
  .p1 {
    font-size: 22px;
    color: #ffffff;
    // overflow: hidden;
  }
  .p2 {
    padding: 2px 5px 2px 5px;
    border: 1px solid #c03b2d;
    background-color: #8a0f02;
  }
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    margin-top: 10px;
  }
  li {
    height: 60px;
    width: 100%;
    border-bottom: 1px solid #ececec;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px 0 10px;
    background-color: #ffffff;
  }
  .li1 {
    display: flex;
    align-items: center;
  }
  .img {
    width: 20px;
    height: 20px;
  }
  .li1 .s1 {
    font-size: 20px;
    margin-left: 20px;
  }
  .button {
    background-color: #bf1f0d;
    width: 50%;
    margin: 20px auto;
  }
`;
interface Array1 {}
interface Array2 {}
export default function MineList() {
  const [tankuang, setTankuang] = useState<{
    visible: boolean;
    rejectId?: string;
    userId?: string;
  }>({
    visible: false,
  });
  const history = useHistory();
  return (
    <>
      <HomePage>
        <div className="body">
          <div className="title">
            <img src="/bg_mine.png" alt="" className="titleimg" />
            <div className="titlediv">
              {/* 头像 */}
              <div
                style={{
                  backgroundColor: "#e9e9eb",
                  width: "55px",
                  height: "55px",
                  borderRadius: "50%",
                }}
              >
                {/* <img src="" alt="" /> */}
              </div>
              <div>
                <p>
                  <span className="p1">科技部领导</span>
                </p>
                <p>
                  <span className="p2">组长</span>
                </p>
              </div>
            </div>
          </div>
          <ul>
            <li>
              <div className="li1">
                <img src="/mine1.png" alt="" className="img" />
                <span className="s1">修改密码</span>
              </div>
              <img src="/mine_right.png" alt="" />
            </li>
            <li>
              <div className="li1">
                <img src="/mine2.png" alt="" className="img" />
                <span className="s1">清除缓存</span>
              </div>
              <div className="li1">
                <span>738kb</span>
                <img src="/mine_right.png" alt="" />
              </div>
            </li>
            <li>
              <div className="li1">
                <img src="/mine3.png" alt="" className="img" />
                <span className="s1">扫码下载</span>
              </div>
              <img src="/mine_right.png" alt="" />
            </li>
            <li>
              <div className="li1">
                <img src="/mine4.png" alt="" className="img" />
                <span className="s1">当前版本</span>
              </div>
              <div className="li1">
                <span>1.6.5</span>
                <img src="/mine_right.png" alt="" />
              </div>
            </li>
          </ul>
          <Button
            type="primary"
            className="button"
            onClick={() => {
              history.push(`/hr/login`);
            }}
          >
            退出登陆
          </Button>
        </div>
      </HomePage>
    </>
  );
}
